<template>
  <div id="addProcess">
    <el-dialog
      :title="title"
      :visible.sync="addVisible"
      width="960px"
      :before-close="handleClose"
    >
      <el-form ref="form" :rules="rules" class="permission-addForm" :model="addForm" label-width="110px">
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="账号名称：" prop="FUserName">
              <el-input v-model.trim="addForm.FUserName" :maxlength="20" show-word-limit />
            </el-form-item>
          </el-col>
          <el-col :span="10" :offset="1">
            <el-form-item label="手机号：" prop="FPhone">
              <el-popover
                v-model="editVisible"
                popper-class="editPhone"
                placement="bottom"
                width="312"
                trigger="manual"
                @hide="closeEdit"
              >
                <div class="edit-title">
                  修改密码
                </div>
                <div class="edit-content">
                  <el-form ref="password" :model="passwordForm" :rules="passwordules" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="设置新密码:" prop="newPassword">
                      <el-input
                        v-model="passwordForm.newPassword"
                        type="password"
                      />
                    </el-form-item>
                    <el-form-item label="确认新密码:" prop="cfmPassword">
                      <el-input v-model="passwordForm.cfmPassword" type="password" />
                    </el-form-item>
                  </el-form>
                </div>
                <div class="edit-footer">
                  <el-button class="edit-close" @click="closeEdit">取消</el-button>
                  <el-button class="edit-cfm" @click="editPassword">确定</el-button>
                </div>

                <el-input slot="reference" v-model.trim="addForm.FPhone" maxlength="11" minlength="11" />
              </el-popover>
            </el-form-item>

          </el-col>
          <el-col v-if="title === '修改人员'" :span="3">
            <el-button @click="editVisible = !editVisible"><i class="el-icon-edit" />
              修改密码</el-button>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="所属部门：" prop="DemandDepartFName">
              <el-input v-model="addForm.DemandDepartFName" clearable @clear="clearDepart('DemandDepartFName','DemandDepartID')">
                <i slot="suffix" class="el-icon-menu" @click="selectDeparment(true,1)" />
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10" :offset="1">
            <el-form-item label="管理部门：">
              <el-input v-model="addForm.ManageDemandDepartName" clearable @clear="clearDepart('ManageDemandDepartName','ManageDemandDepartID')">
                <i slot="suffix" class="el-icon-menu" @click="selectDeparment(true,2)" />
              </el-input>
            </el-form-item>
          </el-col>
          
          <el-col :span="3" v-if="title === '修改人员'&&!addForm.FOAOpenID">
            <el-button @click="bindWXNO()">绑定公众号</el-button>
          </el-col>
          
          <el-col :span="3" v-else-if="title === '修改人员'&&addForm.FOAOpenID">
            <el-button @click="bindWXNO(1)">解绑公众号</el-button>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="岗位：" prop="FRoleName">
              <el-input v-model="addForm.FRoleName" />
            </el-form-item>
          </el-col>
          <el-col class="perchaseMode" :span="10" :offset="1">
            <el-form-item label="下单部门：">
              <el-input v-model="addForm.PurchaseDepartName" clearable @clear="clearDepart('PurchaseDepartName','PurchaseDepartID')">
                <i slot="suffix" class="el-icon-menu" @click="selectDeparment(true,3)" />
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="5">
            <el-form-item label="下单控制：">
              <el-switch
                v-model="addForm.FPurchaseMode"
                active-color="#EC212D"
                inactive-color="#dcdfe6"
                :active-value="0"
                :inactive-value="1"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="接收推送：">
              <el-switch
                v-model="addForm.FReceivePush"
                active-color="#EC212D"
                inactive-color="#dcdfe6"
                :active-value="1"
                :inactive-value="0"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5" :offset="1">
            <el-form-item label="可见价格：">
              <el-switch
                v-model="addForm.FPriceShow"
                active-color="#EC212D"
                inactive-color="#dcdfe6"
                :active-value="1"
                :inactive-value="0"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="全部商品：">
              <el-switch
                v-model="addForm.FShowAllStock"
                active-color="#EC212D"
                inactive-color="#dcdfe6"
                :active-value="1"
                :inactive-value="0"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="屏幕权限：">
              <div class="permission-box">
                <div class="permission-title">
                  屏幕名称
                </div>
                <div class="permission-content">
                  <div class="content-checkbox" style="padding-left:0;">
                    <div v-for="(t,i) in allDemanduserModule" :key="i" class="moduleName">
                      <div
                        style="padding-left:28px;cursor: pointer;"
                        :class="selectModule === i ? 'selectModule' : ''"
                        @click="() => { selectModule = i }"
                      >
                        <el-checkbox
                          v-model="t.checked"
                          @change="(e) => moduleChange(t,e)"
                        />
                        <span :class="t.checked ? 'isChecked' : ''">
                          {{ t.FModuleName }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label-width="0" label="">
              <div class="permission-box">
                <div class="permission-title">
                  屏幕权限
                </div>
                <div class="permission-content permission-list">
                  <div class="content-checkbox checkAll">
                    <el-checkbox
                      v-if="allDemanduserModule[selectModule]"
                      v-model="allDemanduserModule[selectModule].allChecked"
                      :disabled="!allDemanduserModule[selectModule].checked"
                      @change="handleCheckAllChange"
                    >
                      全选
                    </el-checkbox>
                  </div>
                  <div class="content-checkbox">
                    <el-checkbox-group
                      v-if="allDemanduserModule[selectModule]"
                      v-model="allDemanduserModule[selectModule].userFFunctions"
                      :disabled="!allDemanduserModule[selectModule].checked"
                      size="mini"
                      @change="handleCheckChange"
                    >
                      <el-checkbox
                        v-for="item in allDemanduserModule[selectModule].FFunctions"
                        :key="item"
                        :label="item"
                      >{{ item }}</el-checkbox>
                    </el-checkbox-group>
                    <!-- <el-checkbox v-for="(t,i) in allDemanduserModule[selectModule].FFunctions" :key="i">{{ t }}</el-checkbox> -->
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <span v-if="title === '查看人员'">
          <el-button class="close_btn" @click="() => { $emit('addSwitch', false ) }">关 闭</el-button>
        </span>
        <span v-else>
          <el-button class="close_btn" @click="handleClose">取 消</el-button>
          <el-button class="confirm_btn" type="primary" @click="confirm">确 定</el-button>
        </span>
      </span>
    </el-dialog>
    <treeSearch
      ref="tree"
      title="部门"
      :default-arr="defaultArr"
      parent-id="FParentID"
      label="FName"
      fid="FID"
      :tree-visible="treeVisible"
      :is-check-box="idCheckoutBox"
      :show-all="showAll"
      search-url="/mall/mallmanage/demanduserdepart/queryAllDemanduserdepart"
      :shield-highest-node="shieldParentNode"
      :shield-parent-node="false"
      :is-select-parent="isSelectParent"
      @treeConfirm="treeConfirm"
      @treeClose="selectDeparment"
    />
  </div>
</template>

<script>
import treeSearch from '@/components/tree/tree.vue'
import service from '@/utils/request'
import gzhcode from "@/assets/images/gzhcode.jpg"
import QRCode from 'qrcode'
export default {
  components: {
    treeSearch
  },
  props: {
    addVisible: {
      type: [Boolean]
    },
    title: {
      type: [String],
      default: ''
    },
    editFid: {
      type: [Number],
      default: null
    }
  },
  data() {
    const validatePass = (rule, value, callback) => {
      let valid = true
      if (value === '') {
        valid = false
        callback(new Error('请输入密码'))
      }
      if (value.length < 8 || value.length > 16) {
        valid = false
        callback(new Error('密码长度为8-16位'))
      }
      if (value.length > 8 || value.length < 16) {
        const reg = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{8,16}$/
        if (!reg.test(value)) {
          valid = false
          callback(new Error('密码至少包含字母/数字/ 字符两种组合'))
        }
      }
      if (valid) {
        if (this.passwordForm.passwordules !== '') {
          this.$refs.password.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      isSelectParent: false,
      shieldParentNode: false,
      defaultArr: [],
      idCheckoutBox: false,
      treeVisible: false,
      selectModule: 0,
      selectText: '',
      editVisible: false,
      isIndeterminate: true,
      checked: [],
      isAllowOrder: true,
      allowApplication: false,
      addForm: {
        FUserID: '',
        FUserName: '',
        FPhone: '',
        DemandDepartID: '',
        DemandDepartFName: '',
        FRoleName: '',
        ManageDemandDepartID: '',
        ManageDemandDepartName: '',
        PurchaseDepartID: '',
        PurchaseDepartName: '',
        FPurchaseMode: 0,
        FReceivePush:0,
        FPriceShow: 1,
        FShowAllStock: 0
      },
      rules: {
        FUserName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        FPhone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { min: 11, max: 11, message: '请输入11位的手机号', trigger: 'blur' }
        ],
        FRoleName: [
          { required: true, message: '请输入岗位', trigger: 'blur' }
        ],
        DemandDepartFName: [
          { required: true, message: '请选择所属部门', trigger: 'change' }
        ],
        FPurchaseMode: [
          { required: true, message: '请选择下单控制', trigger: 'change' }
        ]
      },
      processArr: [
        {
          text: '一级审批',
          svgClass: 'first-line',
          style: 'background:#F66666;'
        },
        {
          text: '二级审批',
          svgClass: 'second-line',
          style: 'background:#F6A066;'
        },
        {
          text: '三级审批',
          svgClass: 'thired-line',
          style: 'background:#42DFBA;'
        },
        {
          text: '四级审批',
          svgClass: 'fourth-line',
          style: 'background:#6692F6;'
        },
        {
          text: '五级审批',
          svgClass: '',
          style: 'background:#A76DFF;'
        }
      ],
      passwordForm: {
        newPassword: '',
        cfmPassword: ''
      },
      passwordules: {
        newPassword: [{ required: true, validator: validatePass, trigger: 'blur' }],
        cfmPassword: [{ required: true, validator: validatePass2, trigger: 'blur' }]
      },
      allDemanduserModule: [],
      departType: null,
      modeOption: [
        {
          label: '允许下单',
          value: 0
        },
        {
          label: '不允许下单',
          value: 1
        }
      ]
    }
  },
  watch: {
    isAllowOrder(val) {
      this.allowApplication = !val
    },
    addVisible(val) {
      if (val) {
        this.allDemanduserModule = []
        // this.queryAllDemanduserModule()
        const loadingObj = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0,0,0,0.5)',
          target: document.querySelector('.submit-test-dialog')
        })
        service({
          url: '/mall/mallmanage/demanduserdepart/queryAllDemanduserModule',
          method: 'post'
        })
          .then(res => {
            this.toModule(res)
            loadingObj.close()
            if (this.editFid) {
              service({
                url: `/mall/mallmanage/demanduserdepart/queryDemanduserdepartInfo?FID=${this.editFid}`,
                method: 'post'
              })
                .then(res => {
                  const r = JSON.parse(JSON.stringify(res.data))
                  delete r.DemandUserModule
                  r.DemandDepartID = r.DemandDepartFID
                  delete r.DemandDepartFID
                  r['purchaseMode'] = r.FPurchaseMode === 2
                  //   r.FPurchaseMode = r.FPurchaseMode ? r.FPurchaseMode.toString() : ''
                  const ids = []
                  const names = []
                  r.ManagementDepartment.forEach(item => {
                    ids.push(item.FID)
                    names.push(item.FName)
                  })
                  r.ManageDemandDepartID = ids.toString()
                  r.ManageDemandDepartName = names.toString()
                  const FDemandDepartID = []
                  const FDemandDepartName = []
                  r.PurchaseDepartList.forEach(t => {
                    FDemandDepartID.push(t.FDemandDepartID)
                    FDemandDepartName.push(t.FName)
                  })
                  r.PurchaseDepartID = FDemandDepartID.toString()
                  r.PurchaseDepartName = FDemandDepartName.toString()
                  r.FReceivePush=r.FReceivePush||0;
                  this.addForm = r
                  res.data.DemandUserModule.forEach(item => {
                    const i = this.allDemanduserModule.find(t => t.FModuleName === item.FModuleName) || null
                    if (i) {
                      i.checked = true
                      i.userFFunctions = item.FFunctions.split(',')
                      i.allChecked = !!(i.userFFunctions.length === i.FFunctions.length)
                    }
                  })
                  this.$forceUpdate()
                  loadingObj.close()
                })
                .catch(() => {
                  loadingObj.close()
                })
            } else {
              loadingObj.close()
            }
          })
          .catch(() => {
            loadingObj.close()
          })
      }
    }
  },
  created() {

  },
  methods: {
    async bindWXNO(v){
      if(v){
        const loading = this.$loading({
          lock: true,
          text: '解绑中...',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        });
        let codeObj=encodeURIComponent(JSON.stringify({
          ftype:1,
          fuserId:this.addForm.FID
        }))
        service.post(`/mall/wx/applet/wxAccount?codeObj=${codeObj}`).then(res=>{
          loading.close()
          if(res.result){
            this.$notify({
              message: res.msg||"解绑成功",
              type: 'success'
            });
              this.addForm.FOAOpenID="";
              this.$forceUpdate();
          }else{
            this.$notify({
              message: res.msg||"解绑失败",
              type: 'error'
            });
          }
        })
        return
      }
      console.log(this)
      console.log(process.env.VUE_APP_BASE_WX_APP_BIND_HREF,process.env.VUE_APP_BASE_WX_APPID_GZID)
      const h = this.$createElement;
      let param=encodeURIComponent(process.env.VUE_APP_BASE_WX_APP_BIND_HREF+"/bindOpenid.html?userID="+this.addForm.FID)
      const wxcode=await QRCode.toDataURL(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${process.env.VUE_APP_BASE_WX_APPID_GZID}&redirect_uri=${param}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`)
        //console.log(wxcode)
        this.$msgbox({
          customClass:"bind-wx-no",
          title:"绑定公众号",
          showConfirmButton:false,
          message:h('div', { style:"display:flex;justify-content: space-evenly;padding: 25px 0;"}, [
                h("div",{style:"text-align:center;"},[
                  h("p",{ style:"color:#000;font-weight:bold;"},"1.微信扫一扫关注公众号"),
                  
                  h("img",{
                    style:"width: 130px;",
                    domProps:{
                      src:gzhcode
                    }
                  }),
                ]),
                h("div",{style:"text-align:center;"},[
                  h("p",{ style:"color:#000;font-weight:bold;"},"2.微信扫一扫绑定公众号"),
                  
                  h("img",{
                    style:"width: 130px;",
                    domProps:{
                      src:wxcode
                    }
                  }),
                ])
            ])
        })
    },
    moduleChange(t, e) {
      t.allChecked = e
      if (!e) {
        t.userFFunctions = []
      } else {
        t.userFFunctions = t.FFunctions.toString().split(',')
      }
    },
    perchaseChange(val) {
      this.addForm.FPurchaseMode = val ? 2 : 1
    },
    closeEdit() {
      this.passwordForm = {
        newPassword: '',
        cfmPassword: ''
      }
      this.$refs.password.clearValidate()
      this.editVisible = false
    },
    editPassword() {
      this.$refs.password.validate(valid => {
        if (valid) {
          const loadingObj = this.$loading({
            lock: true,
            text: '提交中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0,0,0,0.5)',
            target: document.querySelector('.submit-test-dialog')
          })
          const jsonStr = {
            fUserID: this.addForm.FID,
            fPhone: this.addForm.FPhone,
            fPassword: this.passwordForm.cfmPassword
          }
          const data = new URLSearchParams()
          data.append('jsonStr', JSON.stringify(jsonStr))
          service({
            url: '/mall/updateDemandUserPassword',
            method: 'post',
            data
          })
            .then(res => {
              if (res.result) {
                this.$message.success(res.msg)
                this.closeEdit()
              } else {
                this.$message.error(res.msg)
              }
              loadingObj.close()
            })
            .catch(() => {
              loadingObj.close()
            })
        }
      })
    },
    clearDepart(name, id) {
      this.addForm[name] = this.addForm[id] = ''
      this.$refs.tree.clear()
    },
    selectDeparment(val, type) {
      if (val) {
        if (type === 1) {
          this.defaultArr = [this.addForm.DemandDepartID]
          this.shieldParentNode = true
          this.showAll = true
          this.isSelectParent = false
        } else if (type === 2) {
          this.defaultArr = this.addForm.ManageDemandDepartID.split(',')
          this.shieldParentNode = false
          this.showAll = true
          this.isSelectParent = false
        } else {
          this.defaultArr = this.addForm.PurchaseDepartID.split(',')
          this.shieldParentNode = false
          this.showAll = false
          this.isSelectParent = true
        }
      }
      //   this.idCheckoutBox = (type === 2 || type === 3)
      this.idCheckoutBox = type === 2
      this.departType = type
      this.treeVisible = val
    },
    getTreeId(arr) {
      const ids = []
      function getChildren(Arr) {
        Arr.forEach(t => {
          ids.push(t.FID)
          if (t.children) {
            getChildren(t.children)
          }
        })
      }
      getChildren(arr)
      return ids
    },
    treeConfirm(val) {
      const arr = this.$refs.tree.getValue()
      let ids = []
      const names = []
      arr.forEach(item => {
        ids.push(item.FID)
        names.push(item.FName)
      })
      if (this.departType === 3) {
        ids = this.getTreeId(arr)
      }
      if (this.departType === 1) {
        this.addForm.DemandDepartID = val ? val.FID : ''
        this.addForm.DemandDepartFName = val ? val.FName : ''
      } else if (this.departType === 2) {
        this.addForm.ManageDemandDepartID = ids.toString()
        this.addForm.ManageDemandDepartName = names.toString()
      } else {
        this.addForm.PurchaseDepartID = ids.toString()
        this.addForm.PurchaseDepartName = names.toString()
      }
      this.selectDeparment(false)
    },
    confirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const loadingObj = this.$loading({
            lock: true,
            text: '提交中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0,0,0,0.5)',
            target: document.querySelector('.submit-test-dialog')
          })
          const jsonStr = JSON.parse(JSON.stringify(this.addForm))
          jsonStr.FPurchaseMode = Number(jsonStr.FPurchaseMode)
          delete jsonStr.DemandDepartFName
          delete jsonStr.ManageDemandDepartName
          delete jsonStr.ManagementDepartment
          delete jsonStr.PurchaseDepartName
          if (!this.editFid) {
            jsonStr.FStatus = 0
          } else {
            jsonStr['FUserID'] = jsonStr.FID
          }
          delete jsonStr.FID
          jsonStr.FModule = []
          this.allDemanduserModule.forEach(item => {
            if (item.checked) {
              const FFunctions = item.userFFunctions.toString()
              jsonStr.FModule.push({
                FModuleId: item.FID,
                FFunctions
              })
            }
          })
          const data = new URLSearchParams()
          data.append('jsonStr', JSON.stringify(jsonStr))
          service({
            url: '/mall/mallmanage/demanduserdepart/insertOrUpdateDemanduser',
            method: 'post',
            data
          })
            .then(res => {
              loadingObj.close()
              if (res.result) {
                const msg = this.editFid ? '修改成功' : '新增成功'
                this.$message.success(msg)
                this.$emit('onSearch')
                this.handleClose()
              } else {
                this.$message.error(res.msg)
              }
            })
            .catch(() => {
              loadingObj.close()
            })
        }
      })
    },
    queryAllDemanduserModule() {
      const loadingObj = this.$loading({
        lock: true,
        text: '提交中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0,0,0,0.5)',
        target: document.querySelector('.submit-test-dialog')
      })
      service({
        url: '/mall/mallmanage/demanduserdepart/queryAllDemanduserModule',
        method: 'post'
      })
        .then(res => {
          this.toModule(res)
          loadingObj.close()
        })
        .catch(() => {
          loadingObj.close()
        })
    },
    toModule(res) {
      res.data.forEach(item => {
        item.checked = !this.editFid
        item.FFunctions = item.FFunctions.split(',')
        item.allChecked = true
        item.userFFunctions = item.FFunctions
      })
      this.allDemanduserModule = res.data
    },
    handleCheckAllChange() {
      const t = this.allDemanduserModule[this.selectModule]
      t.userFFunctions = t.allChecked ? t.FFunctions : []
    },
    handleCheckChange() {
      const t = this.allDemanduserModule[this.selectModule]
      const l1 = t.userFFunctions.length
      const l2 = t.FFunctions.length
      t.allChecked = l1 === l2
    },
    handleClose() {
      this.editVisible = false
      this.addForm.FPurchaseMode = this.addForm.FShowAllStock = 0
      this.addForm.FPriceShow = 1
      this.addForm.FReceivePush=0;
      this.addForm.ManageDemandDepartID = this.addForm.ManageDemandDepartName = this.addForm.DemandDepartID = ''
      this.addForm.PurchaseDepartID = this.addForm.PurchaseDepartName = ''
      this.PurchaseDepartID = this.PurchaseDepartName = ''
      this.$refs.form.resetFields()
      this.$emit('addSwitch', false)
    }
  }
}
</script>

<style lang='scss' scoped>
.el-popover {
    .edit-title {
        height: 35px;
        line-height: 35px;
        padding-left: 12px;
        border-radius: 4px 4px 0 0;
        font-size: 16px;
        background: #EC212D;
        color: #fff;
    }
    .edit-content {
        width:100%;
        margin-top: 17px;
        padding:0 26px 0 17px;
        border-bottom: 1px solid #F2F3F6;
    }
    .edit-footer {
        padding-right: 14px;
        display: flex;
        justify-content: right;
        align-items: center;
        height: 46px;
        .edit-close {
            border: 1px solid #C4CBD7;
            color: #C4CBD7;
        }
        .edit-cfm {
            background: #EC212D;
            color: #fff;
        }
    }
}
#addProcess {
    .permission-addForm {
        .permission-box {
            width: 208px;
            height: 243px;
            border-radius: 4px;
            .permission-title {
                padding-left: 28px;
                height: 36px;
                line-height: 36px;
                background: #FFE5E6;
                border: 1px solid #EC212D;
                font-size: 16px;
                color: #5C5F67;
            }
            .permission-content {
                height: 207px;
                border: 1px solid #EFF0F2;
                border-top: 0;
                overflow-y: auto;
                .content-checkbox {
                    width: 100%;
                    padding-left: 28px;
                }
                .isSelect {
                    background-color: #EFF0F2;
                }
                .isChecked {
                    color: #EC212D;
                }
                .selectModule {
                    background-color: #EFF0F2;
                }
            }
            .checkAll {
                    border-bottom: 1px solid #EFF0F2;
                }
        }
    }
    .dialog-footer {
        .close_btn {
            border: 1px solid #C4CBD7;
            color: #C4CBD7;
        }
    }
}
</style>
<style lang='scss'>
.editPhone {
    .el-popover {
        border: 0;
        // top: 52px !important;
        padding: 0 !important;
        .popper__arrow {
            border-bottom-color: #EC212D  !important;
        }
        .popper__arrow::after {
            border-bottom-color: #EC212D !important;
        }
        .edit-content {
            .el-input__inner {
                height: 32px;
            }
        }
        .edit-footer {
            .el-button {
                position: relative;
                width: 47px;
                height: 24px;
                font-size: 12px;
                span {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%,-50%);
                }
            }
        }
    }
}

#addProcess {

    .el-dialog {
        position: relative;
        top: 45% !important;
        height: 622px;
        border-radius: 10px;
    }
    .el-dialog__header {
        height: 40px;
        font-size: 16px;
        padding-left: 23px;
        border-radius: 10px 10px 0 0;
    }
    .el-dialog__body {
        height: 508px;
        padding: 26px 46px 0;
        border-bottom: 1px solid #C4CBD7;
    }
    .el-dialog__footer {
        display: flex;
        align-items: center;
        justify-content: right;
        height: 73px;
        padding: 0;
        padding-right: 35px;
    }
    .dialog-footer {
        .el-button {
            width: 80px;
            height: 36px;
        }
    }
    .permission-addForm {
        .perchaseMode {
            .el-checkbox__label {
                font-size: 16px;
            }
            .el-checkbox__input {
                position: relative;
                top: -1px;
            }
        }
        .el-popover__reference {
            border: 0;
            font-size: 16px;
            color: #EC212D;
        }
        .el-form-item__label {
            font-size: 16px !important;
            color: #676871;
        }
        .el-input__suffix {
            right: 10px;
        }
        .el-form-item {
            margin-bottom: 17px;
        }
        .permission-content {
            .el-checkbox__label {
                font-size: 16px;
            }
            // .el-checkbox {
            //     width: 100%;
            //     padding-left: 28px;
            // }
            .moduleName {
                .el-checkbox {
                    margin-right: 10px;
                }
            }
        }
    }
    .process-content {
        .el-input__suffix {
            top: 8px;
            font-size: 24px;
        }
        .el-input__inner {
            border: 0;
        }
    }
}
.bind-wx-no{
  border-color:#EC212D;
  width: 500px;
}
.bind-wx-no .el-message-box__content{
  padding: 0;
}
.bind-wx-no .el-message-box__header{
  text-align: center;
    background: #EC212D;
    padding-top: 10px;
}
.bind-wx-no  .el-message-box__title{

  color: #fff;
}
.bind-wx-no .el-message-box__headerbtn{
  top:10px;
}
.bind-wx-no .el-icon-close:hover{
  color: #000;
}
</style>
